export default __webpack_public_path__ + "static/media/room-sweet_compressed.625c6414.mp4";